import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import routes from "./routesConfig";
import { ReturnNotification } from "../components/common/ReturnNotification";
import { InAppNotification } from "../components/common/InAppNotification";
import { NotificationSubscription } from "../components/common/NotificationSubscription";
import { useEffect } from "react";
import { useAppSelector } from "../components/hooks";
import { NotificationMd } from "../models/notification";
import { PageRoutes } from "../constants/historyGaming";
import { loginGQL, useLegacyMutation } from "@onmo/graphql/legacyGraphql";
import { selectIsAuthenticated, updateSignInState } from "@onmo/auth";
import i18next, { changeLanguage } from "i18next";
import { useRefetchNotification } from "../hooks/resolvers/notification/useRefetchNotification";
import { useQuery } from "@apollo/client";
import { meGQL } from "@onmo/graphql/graphql";
import GamingLoading from "../components/common/GamingLoading/GamingLoading";
import { useOnlineStatus } from "../hooks/useOnlineStatus";
import { NoInternet } from "../components/common/NoInternet";

const RoutesLogged = () => {
  const [login] = useLegacyMutation(loginGQL);
  const { data: dataMe } = useQuery(meGQL);
  const isOnline = useOnlineStatus();
  const { notifications, language } = useRefetchNotification();
  const userNotifications =
    NotificationMd.filterNotificationType(notifications);
  const inAppNotificationData = useAppSelector(
    (state) => state.inAppNotification,
  );
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  const recentNotificationTime =
    localStorage.getItem("recentNotificationTime") || "";
  const recentTime =
    recentNotificationTime !== ""
      ? new Date(recentNotificationTime).getTime()
      : 0;
  const newNotificationTime = new Date(
    userNotifications[0]?.createdAt,
  ).getTime();

  useEffect(() => {
    if (!language) return;
    // Only update if different language
    if (i18next.language !== language) {
      changeLanguage(language);
    }
  }, [language]);

  useEffect(() => {
    login().then(() => updateSignInState());
  }, [login]);

  if (isAuthenticated && !dataMe) return <GamingLoading />;
  if (!isOnline) return <NoInternet />;

  return (
    <>
      {userNotifications?.length > 0 && newNotificationTime > recentTime && (
        <ReturnNotification userNotifications={userNotifications} />
      )}
      {inAppNotificationData.data && <InAppNotification />}
      <Routes>
        {routes.map(({ path, element }, idx) => (
          <Route key={path + idx} path={path} element={element} />
        ))}
        <Route
          path="*"
          element={<Navigate to={PageRoutes.HomePage} replace />}
        />
      </Routes>
      <NotificationSubscription />
    </>
  );
};

export default RoutesLogged;
